import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import useInterval from '../../../../hooks/useInterval';
import { getRandomItemFromArray, getRandomNumber } from '../../../../helper';

export const RoomOfQuestionsContext = React.createContext();

const defaultRows = [2, 4, 6, 8, 10];
const defaultFlashRows = [1, 3, 5, 7, 9, 11];

const RoomOfQuestionsProvider = ({ children, questions }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentQuestions, setCurrentQuestions] = useState([]);
  const [currentFlashes, setCurrentFlashes] = useState([]);
  const [availableRows, setAvailableRows] = useState(defaultRows);
  const [availableFlashRows, setAvailableFlashRows] = useState(defaultFlashRows);

  const addQuestion = question => {
    const row = getRandomItemFromArray(availableRows) || 2;
    setAvailableRows(availableRows.filter(item => item !== row));

    return setCurrentQuestions(prev => [...prev, { row, ...question }]);
  };

  const removeQuestion = index => {
    const removedQuestion = currentQuestions[index];
    setAvailableRows(prev => [...prev, removedQuestion.row]);
    setCurrentQuestions(prev => prev.filter((_, i) => i !== index));
  };

  const addFlash = () => {
    const row = getRandomItemFromArray(availableFlashRows) || 1;
    const delay = getRandomNumber(0, 2);
    setAvailableFlashRows(availableFlashRows.filter(item => item !== row));
    return setCurrentFlashes(prev => [...prev, { row, delay }]);
  };

  const removeFlash = index => {
    const removedFlash = currentFlashes[index];
    setAvailableFlashRows(prev => [...prev, removedFlash.row]);
    setCurrentFlashes(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    addQuestion(questions[0]);
    addFlash();
  }, []);

  useInterval(() => {
    addQuestion(questions[activeIndex + 1 < questions.length ? activeIndex + 1 : 0]);
    addFlash();

    setActiveIndex(prev => (activeIndex + 1 < questions.length ? prev + 1 : 0));
  }, 7000);

  return (
    <RoomOfQuestionsContext.Provider
      value={{
        activeIndex,
        currentQuestions,
        currentFlashes,
        questions,
        addQuestion,
        removeQuestion,
        removeFlash
      }}
    >
      {children}
    </RoomOfQuestionsContext.Provider>
  );
};

RoomOfQuestionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      question: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  ).isRequired
};

export const RoomOfQuestionsConsumer = RoomOfQuestionsContext.Consumer;

export default RoomOfQuestionsProvider;
